(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    function initializeStickyOffset() {
      var header = document.getElementById('shopify-section-header');
      if (!header || header.getAttribute('data-sticky-offset-ready') === 'true') return;

      var announcement = header.querySelector('.announcement-bar');
      header.setAttribute('data-sticky-offset-ready', 'true');

      function updateStickyOffset() {
        var height = announcement ? announcement.offsetHeight : 0;
        header.style.setProperty('--intexca-announcement-height', height + 'px');
      }

      updateStickyOffset();
      window.addEventListener('resize', updateStickyOffset, { passive: true });

      if (window.ResizeObserver && announcement) {
        header.intexcaAnnouncementObserver = new ResizeObserver(updateStickyOffset);
        header.intexcaAnnouncementObserver.observe(announcement);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeStickyOffset);
    } else {
      initializeStickyOffset();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initializeSlider(slider) {
      if (slider.getAttribute('data-new-arrivals-ready') === 'true') return;

      var viewport = slider.querySelector('[data-new-arrivals-viewport]');
      var previousButton = slider.querySelector('[data-new-arrivals-previous]');
      var nextButton = slider.querySelector('[data-new-arrivals-next]');
      var item = slider.querySelector('.intexca-new-arrivals__item');

      if (!viewport || !previousButton || !nextButton || !item) return;

      slider.setAttribute('data-new-arrivals-ready', 'true');

      function scrollAmount() {
        var track = slider.querySelector('.intexca-new-arrivals__track');
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return (item.getBoundingClientRect().width + gap) * 2;
      }

      function updateButtons() {
        var maximum = viewport.scrollWidth - viewport.clientWidth;
        previousButton.disabled = viewport.scrollLeft <= 2;
        nextButton.disabled = viewport.scrollLeft >= maximum - 2;
      }

      previousButton.addEventListener('click', function() {
        viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', function() {
        viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      viewport.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

    function initializeAllSliders(root) {
      var scope = root || document;
      var sliders = scope.querySelectorAll('[data-new-arrivals-slider]');
      Array.prototype.forEach.call(sliders, initializeSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initializeAllSliders(document);
      });
    } else {
      initializeAllSliders(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      initializeAllSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
